var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4C10.5 21.225 11.175 21.9 12 21.9H18C18.825 21.9 19.5 21.225 19.5 20.4V11.4H10.5V20.4ZM20.25 9.15002H17.625L16.875 8.40002H13.125L12.375 9.15002H9.75V10.65H20.25V9.15002Z",
    fill: "#D43939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.7386dbba6b258d5c8b7b6fb7b3f9a084.svg";
export { ForwardRef as ReactComponent };